{
    "name": "Aj\u00ed Dulce Pepper",
    "binomial_name": "Capsicum chinense",
    "common_names": [
        "ajicito",
        "aji dulce",
        "sweet chili"
    ],
    "description": "Aj\u00ed dulce (or sweet chili) peppers are a specific Venezuelan variety of Capsicum chinense peppers that are related to the habanero but have a much milder, smoky flavor. Their 5cm long fruits start green and turn red as they ripen. The plants are small and compact well-suited to container gardening.",
    "sun_requirements": "Full Sun",
    "sowing_method": "Direct seed indoors, transplant seedlings outside after hardening off.",
    "spread": 0,
    "row_spacing": 0,
    "height": 0,
    "growing_degree_days": 0,
    "companions": [],
    "image": "",
    "icon": "/crops/icons/aji-dulce-pepper.avif"
}